<!--
 * @Author: shuchang
 * @Date: 2022-03-21 14:55:46
 * @LastEditors: shuchang
 * @LastEditTime: 2022-05-12 15:28:39
 * @Description: 
-->
<template>
    <div class="labelSet flexB borderBox">
        <!-- <div v-for="(item,index) in tagsList" :key="item.path" @click="closeTags(index)">{{item.title}}</div> -->
         <el-tabs v-model="editableTabsValue" closable @tab-click="handleClick" @tab-remove="closeTags" :style="{'--color':tabColor,'--bcolor':tabBcolor}">
            <el-tab-pane 
                :key="item.path + item.sysId"
                v-for="(item) in tagsList"
                :label="item.title"
                :name="item.path +'-'+ item.sysId"
                :closable="false"
            >
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import bus from './bus';
    import { getMainPage } from "../../utils/getMain";
    export default {
        name: "labelSet",
        props: ['list','activePath','color','bcolor'],
        data() {
            return {
                tagsList: [],
                editableTabsValue:'',
                indexObj:{},
                indexArr:[],
                tabColor:'#e6f7ff',
                tabBcolor:'#165dff'
            }
        },
        methods: {
             handleClick(tab, event){
                this.goTo(this.editableTabsValue,tab.index)
            },
            closeTags(data) {
                let i;
                this.tagsList.forEach((ele,index) => {
                    if(ele.path  == data.split('-')[0]) {
                        i = index;
                    }
                });
                
                const delItem = this.tagsList.splice(i, 1)[0];
                const item = this.tagsList[i] ? this.tagsList[i] : this.tagsList[i - 1];
                if(this.list){
                    if(item){
                        this.editableTabsValue = item.path + '-'+item.sysId ;
                    }
                    this.$emit('closeLabel',item)
                } else {
                    if(item){
                        this.$router.push(item.path)
                        this.editableTabsValue = item.path + '-' + JSON.parse(sessionStorage.getItem('data')).sysId;
                    } else {
                        // if(data!=getMainPage()){
                        //     this.$router.push(getMainPage());
                        //     // this.editableTabsValue = '/home'
                        // }
                    }
                }
            },
            // 设置标签
            setTags(route){
                if(!this.list){
                    this.editableTabsValue = route.fullPath+ '-'+JSON.parse(sessionStorage.getItem('data')).sysId;
                    const isExist = this.tagsList.some(item => {
                        return item.path === route.fullPath;
                    })
                    if(route.meta.hidden){
                        return;
                    }
                    if(!isExist){
                        // if(this.tagsList.length >= 8){
                        //     this.tagsList.shift();
                        // }
                        this.tagsList.push({
                            title: route.name,
                            path: route.fullPath,
                            name: route.matched[1].components.default.name,
                            sysId: JSON.parse(sessionStorage.getItem('data')).sysId
                        })
                    }
                    bus.$emit('tags', this.tagsList);
                    
                }
            },

            goTo(data,index) {
                if(this.list && this.list.length > 0){
                    this.$emit('getUrl',this.list[index])
                } else {
                     this.$store.commit('SET_PATH',{})
                    this.$router.push({path:data.split('-')[0],})
                }
            },
            getMenuIndex(){
                this.digui(JSON.parse(sessionStorage.getItem('data')).menuPaths); 
                this.$nextTick(() =>{
                    if(document.getElementById(`tab-${this.indexObj.path}-${this.indexObj.sysId}`)){
                         document.getElementById(`tab-${this.indexObj.path}-${this.indexObj.sysId}`).getElementsByClassName('el-icon-close')[0].style.display = 'none'
                    } 
                })
            },
            digui(data){
                data.forEach(ele =>{
                    if(ele.index) {
                        this.indexObj =  {...ele,sysId:JSON.parse(sessionStorage.getItem('data')).sysId}
                    } else {
                        this.digui(ele.children)
                    }
                })
            },
            handleTags(command){
                command === 'other' ? this.closeOther() : this.closeAll();
            }
        },
        computed: {
            showTags() {
                return this.tagsList.length > 0;
            }
        },
        watch:{
            $route(newValue,){
                if(!this.list){
                    this.setTags(newValue);
                }else {
                    this.editableTabsValue = newValue.path+'-' + JSON.parse(sessionStorage.getItem('data')).sysId;
                }
            },
            list:{
                handler: function (newValue) {
                    if(newValue && newValue.length > 0){
                        this.tagsList = newValue;
                        this.indexArr = [];
                        this.tagsList.forEach(ele =>{
                            ele.path = ele.menuUrl;
                            ele.title = ele.menuName;
                            if(ele.menuMark == 'index'){
                                this.indexArr.push(ele)
                            }
                        }) 
                    }
                },
                deep: true
            },
            activePath(newValue){
                this.editableTabsValue = newValue;
            }
        },
        created(){
            if(!this.list){
                this.getMenuIndex();
                this.setTags(this.$route);
                
                // 监听关闭当前页面的标签页
                bus.$on('close_current_tags', () => {
                    for (let i = 0, len = this.tagsList.length; i < len; i++) {
                        const item = this.tagsList[i];
                        if(item.path === this.$route.fullPath){
                            if(i < len - 1){
                                this.$router.push(this.tagsList[i+1].path);
                            }else if(i > 0){
                                this.$router.push(this.tagsList[i-1].path);
                            }else{
                                this.$router.push('/home');
                            }
                            this.tagsList.splice(i, 1);
                            break;
                        }
                    }
                })
            }
            if(this.color){
                this.tabColor = this.color;
            }
            if(this.bcolor){
                this.tabBcolor = this.bcolor;
            }
        },
        updated(){
            if(!this.list){
               this.$nextTick(() =>{
                    if(document.getElementById(`tab-${this.indexObj.path}-${this.indexObj.sysId}`)){
                         document.getElementById(`tab-${this.indexObj.path}-${this.indexObj.sysId}`).getElementsByClassName('el-icon-close')[0].style.display = 'none'
                    } 
                })
            } else {
                this.$nextTick(() =>{
                    this.indexArr.forEach(ele =>{
                        if(document.getElementById(`tab-${ele.path}-${ele.sysId}`)){
                            document.getElementById(`tab-${ele.path}-${ele.sysId}`).getElementsByClassName('el-icon-close')[0].style.display = 'none'
                        }
                    })
                })
            }
        }
    }
</script>
<style  scoped lang="scss">
     .el-tabs{
        width:100%;
         /deep/{
            .el-tabs__header{
                margin:0px;
            }
            .el-tabs__active-bar {
                width:0px!important;
            }
            .el-tabs__item {
                padding: 7px 0 7px 12px;
                // margin: 3px 5px 2px 3px;
                // border-radius: 4px;
                font-size: 14px;
                cursor: pointer;
                height: 44px;
                line-height:40px;
                padding:0 15px!important;
                vertical-align: middle;
                color: #303133;
                -webkit-transition: all .3s ease-in;
                -moz-transition: all .3s ease-in;
                transition: all .3s ease-in;
                font-weight: 550;
                &:hover{
                    background: var(--color);
                }
                
                .el-icon-close{
                    // background: #F5F7FA;
                    // border-radius: 10px;
                    padding: 4px
                }
            }
            .el-tabs__item.is-active {
                font-weight: 400;
                color: #303133;
                background: var(--color);
                border-bottom: 2px solid var(--bcolor) ;
                font-weight: bold;
            }
            .el-tabs__item:focus.is-active.is-focus:not(:active){
                    box-shadow:none
                }
            .el-tabs__nav-wrap::after{
                background-color: transparent;
            }
            .el-tabs__nav-next,.el-tabs__nav-prev{
                
                color: #000;
                font-weight: 900;
            }
            .el-tabs__nav-wrap.is-scrollable {
                padding: 0 40px;
            }

            .el-tabs__nav-next,
            .el-tabs__nav-prev {
                font-size: 16px;
                font-weight: bold;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                line-height: 40px;
                i {
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
    }
    
    .tags {
        position: relative;
        height: 30px;
        overflow: hidden;
        background: #fff;
        padding-right: 120px;
        box-shadow: 0 5px 10px #ddd;
    }
    .tags ul {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }
    
    .tags-li:not(.active):hover {
        background: #f8f8f8;
    }
    
    .tags-li-title {
        float: left;
        // max-width: 72px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #666;
    }
    .tags-li.active .tags-li-title {
        color: rgba(76,86,103,1);
    }
    .tags-close-box {
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 1px;
        text-align: center;
        width: 110px;
        height: 30px;
        background: #fff;
        box-shadow: -3px 0 15px 3px rgba(0, 0, 0, .1);
        z-index: 10;
    }
</style>